import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

/**
 *
 * Search for mission objectives.
 * @param listMetaData {ListMetaData}
 * @returns {Promise<AxiosResponse<object[]>>}
 * @constructor
 */
const FindMany = async listMetaData => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.MISSION_OBJECTIVES,
  {
    ...listMetaData.toAxiosRequestParams()
  }
)

const MissionObjectiveService = {
  FindMany
}

export default MissionObjectiveService
